const setLocalStorage = (key: string, value: string) => {
  localStorage.setItem(key, value);
};
const getLocalStorage = (key: string) => {
  localStorage.getItem(key);
};

const removeLocalStorage = (key: string) => {
  localStorage.removeItem(key);
};

export { setLocalStorage, removeLocalStorage, getLocalStorage };
